import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Menu } from "primereact/menu";
import React, { useEffect, useRef, useCallback, useMemo } from "react";
import { useRBAC } from "../../hooks/RBACContext";
import { WRITE_ACCESS_CTA } from "../../utils/Constants";
import "./DisplayTable.css";

const DisplayTable = ({
  data,
  parmKey,
  menuOptions,
  tableHeaders,
  setRowData,
  selectedPriceSchedules,
  setSelectedPriceSchedules,
  selectMode = false,
  displayMode = false,
}) => {
  const menuLeft = useRef(null);

  const handleGearClick = (event, rowData) => {
    event.stopPropagation(); // Prevent event propagation
    setRowData(rowData);
    menuLeft.current.toggle(event);
  };
  const { writeAccess } = useRBAC();
  const filterMenuOptions = menuOptions.filter((menuOption) => {
    if (
      !writeAccess &&
      WRITE_ACCESS_CTA.some((option) =>
        menuOption.label.toUpperCase().includes(option)
      )
    ) {
      return false;
    }
    return true;
  });

  const onSelectionChange = (e) => {
    setSelectedPriceSchedules(e.value || []);
  };

  const isRowSelected = useCallback(
    (rowData) => {
      const filtered = selectedPriceSchedules.filter(
        (schedule) => rowData[parmKey] === schedule[parmKey]
      );
      return filtered.length ? true : false;
    },
    [selectedPriceSchedules]
  );

  const gearIconTemplate = (rowData) => {
    return (
      <Button
        className="gear-button"
        rounded
        aria-label="settings"
        onClick={(event) => handleGearClick(event, rowData)}
      >
        <span className="material-icons">settings</span>
      </Button>
    );
  };

   const checkboxColumn = useMemo(() => {
		const checkboxColumnDef = {
			input: {
				tabIndex: 0,
				onKeyDown: (e) => {
					if (e.key === "Enter") {
						e.preventDefault();
						e.target.click();
					}
				},
			},
		};

		if (selectMode || displayMode) return null;

		return (
			<Column
				selectionMode="multiple"
				headerStyle={{ width: "2em" }}
				pt={{
					headerCheckbox: checkboxColumnDef,
					rowCheckbox: checkboxColumnDef,
				}}
			/>
		);
	}, [selectMode, displayMode]);

  useEffect(() => {
    setSelectedPriceSchedules([]); // Reset selections whenever data changes
  }, [data]);

  return (
    <div className="table-container">
      <DataTable
        value={data}
        paginator={false}
        dataKey={parmKey}
        selectionMode={null}
        selection={selectedPriceSchedules}
        onSelectionChange={onSelectionChange}
        emptyMessage="No data found"
        showGridlines
        stripedRows
        rowClassName={(rowData) => (isRowSelected(rowData) ? "selected" : "")}
      >
       {checkboxColumn}
        {!displayMode ? (
          <Column body={gearIconTemplate} headerStyle={{ width: "2em" }} />
        ) : null}
        {tableHeaders.map(({ field, header, body, style }) => (
          <Column
            key={field}
            field={field}
            header={header}
            body={body}
            style={style}
            className="table-cell"
          />
        ))}
      </DataTable>
      <Menu
        className="gear-option"
        model={filterMenuOptions}
        popup
        ref={menuLeft}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.stopPropagation();
          }
        }}
      />
    </div>
  );
};

export default DisplayTable;
